import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ButtonWrapper from "../../../components/Button";
import InputWrapper from "../../../layout/inputWrapper";
import { InfoBox } from "../../../components/StyledComponent";
import { typeOfIdProof } from "../../../../TCPForms/data";
// import useDepartmentSelector from "../../../../TCPForms/hooks/useDepartmentSelector";
import SortingAlphabatically from "../../../reusableComponents/SortingAlphbatically";
import { Col, Row, Container } from "react-bootstrap";
import { TLService } from "../../../../../../../../../libraries/src/services/elements/TL";
import { Toast } from "@egovernments/digit-ui-react-components";

const SubStep4 = ({ formData, handleSubTabChange, isEmployee, setShowToast, showToast, isReapply, officesList }) => {
  const { t } = useTranslation();
  // const [, applicationFlow] = useDepartmentSelector();
  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  const tradeType = formData?.tradeLicenseDetail?.tradeUnits?.[0]?.tradeType === "ARCHITECT.CLASSA";
  // const avpAuthorityList1 =
  //   !isDistrictDataLoading && applicationFlow
  //     ? districtData?.filter((district) => district.code?.includes("up.avp"))?.[0]?.boundary?.filter((ele) => ele.hasOwnProperty("location"))
  //     : [];
  // const daAuthorityList1 =
  //   !isDistrictDataLoading && applicationFlow
  //     ? districtData?.filter((district) => district.code?.includes("up.da"))?.[0]?.boundary?.filter((ele) => ele.hasOwnProperty("location"))
  //     : [];
  const updistricts = isDistrictDataLoading
    ? []
    : districtData.map((district) => ({
        label: district.name,
        value: district.name,
        name: district.name,
      }));
  function filterOfficeNames(completeList) {
    const officeNames = completeList.map((office) => ({ value: office.name, label: office.name }));
    return officeNames;
  }
  // const officesList = applicationFlow == "DA" ? filterOfficeNames(daAuthorityList1) : filterOfficeNames(avpAuthorityList1);

  const defaultValues = {
    ...formData,
  };
  const { handleSubmit, watch, control, setValue } = useForm({ defaultValues });
  const watchRegistrationType = formData?.registrationType;
  const watchVerifyingAuthority = watch("authorityName");
  const closeToast = () => {
    setShowToast(null);
  };

  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(() => setShowToast(null), 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  // useEffect(() => {
  //   const office = watchVerifyingAuthority?.split(" ")[0];
  //   setValue("authorityName", office);
  // }, [watchVerifyingAuthority]);

  const checkCOAValidate = async (applicationData) => {
    const licenses = [
      {
        tenantId: applicationData?.tenantId,
        id: applicationData?.id,
        tradeLicenseDetail: {
          owners: [
            {
              architectureNo: applicationData?.tradeLicenseDetail?.owners?.[0]?.architectureNo,
            },
          ],
        },
      },
    ];
    try {
      const response = await TLService.coaValidate({ licenses });
      if (response?.message === "Certificate number not exists.") {
        return true;
      }
      return false;
    } catch (error) {
      setShowToast({ error: true, message: `Certificate No. already exsist` });
      throw new Error(error);
    }
  };

  const onSubmit = async (data) => {
    try {
      const isAlready = formData?.tradeLicenseDetail?.owners?.[0]?.architectureNo 
      const isNotChanging = formData?.tradeLicenseDetail?.owners?.[0]?.architectureNo === data?.tradeLicenseDetail?.owners?.[0]?.architectureNo 

      const isUnique = isAlready && isNotChanging ? true :  await checkCOAValidate(data);
      if (isUnique) {
        handleSubTabChange(4, data);
      } else {
        setShowToast({ error: true, message: `Certificate No. already exsist` });
      }
    } catch (error) {
      throw new Error(error);
    }
  };
  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("LABEL_REGISTRATION_DETAILS")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(typeOfIdProof)}
                  label="ID Proof Type"
                  placeholder={t("LABEL_SELECT_ID")}
                  name="idProofType"
                  defaultValue={formData?.idProofType}
                  disabled={isEmployee || (isReapply && formData?.idProofType)}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              {!(watchRegistrationType === "Supervisor" || watchRegistrationType === "Graduate Civil Engineer") ? (
                <Col>
                  <InputWrapper
                    label={watchRegistrationType === "Architect" ? t("Registration Valid Upto") : t("LABEL_VALID_UPTO")}
                    control={control}
                    placeholder="Select Date"
                    type="datePicker"
                    name="validupto"
                    mandatory={tradeType}
                    defaultValue={formData?.validupto}
                    disabled={isEmployee || (isReapply && formData?.validupto)}
                    disablePast={true}
                    validation={{
                      required: {
                        value: watchRegistrationType === "Architect",
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label={
                    watchRegistrationType === "Architect"
                      ? "COA Registration No."
                      : watchRegistrationType === "Graduate Civil Engineer"
                      ? "IEI Registration No."
                      : "Qualification Certificate No."
                  }
                  control={control}
                  placeholder="Enter Certificate No"
                  type="textInput"
                  name="tradeLicenseDetail.owners.[0].architectureNo"
                  mandatory={watchRegistrationType !== "Supervisor"}
                  customLabel={"long-label"}
                  defaultValue={formData?.tradeLicenseDetail?.owners?.[0]?.architectureNo}
                  disabled={isEmployee || (isReapply && formData?.tradeLicenseDetail?.owners?.[0]?.architectureNo)}
                  validation={{
                    required: {
                      value: watchRegistrationType !== "Supervisor",
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(officesList)}
                  label={t("LABEL_VERIFYING_AUTHORITY")}
                  placeholder={t("LABEL_SELECT_AUTHORITY_NAME")}
                  name="authorityName"
                  defaultValue={formData?.authorityName}
                  disabled={isEmployee || (isReapply && formData?.authorityName)}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: "1em" }}>
              <Col xs={12} md={12}>
                {watchVerifyingAuthority && !isEmployee && (
                  <InfoBox>
                    Documents will be verified at the selected authority <span>*</span>
                  </InfoBox>
                )}
              </Col>
            </Row>
          </Container>
        </div>
        {!isEmployee && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Prev"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleSubTabChange(2)}
              />
              <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
            </div>
          </div>
        )}
      </form>
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </section>
  );
};

export default SubStep4;
